import { isEmpty } from '@jjj/components';
import actions from './actions';
import { keyBy } from '../../../helpers/core';
import { getError, createReducer } from '../../../helpers/reducer';
import { t } from '../../../i18n';

const initState = {
  editForm: null,
  baseError: null,
};

const initialData = {
  name: '',
  order: 0,
};

function validate(attr, value) {
  let error = '';

  if (attr === 'name') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.editUnmatchedOption.name_label') });
    }
  }

  return error;
}

function onLoad(state, { payload }) {
  const { item } = payload;

  const propsArray = Object.keys(item);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: item[prop],
      error: validate(prop, item[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    editForm,
  };
}

function onCreate(state) {
  const propsArray = Object.keys(initialData);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: initialData[prop],
      error: validate(prop, initialData[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    editForm,
  };
}

function onClearStore() {
  return { ...initState };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onSaveError(state, { payload }) {
  const { data } = payload;

  const propsArray = Object.entries(state.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        error: getError(entry[0], data),
        touched: true,
      };
    },
  );

  const baseError = data.base ? data.base[0] : null;

  return {
    ...state,
    editForm,
    baseError,
  };
}

export { validate };
export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.CREATE]: onCreate,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.TOUCH]: onTouch,
  [actions.SAVE_ERROR]: onSaveError,
});
